import { useLang } from './LanguageContext'
import { LANGUAGES } from './translations'

/**
 * Language dropdown shared by the marketing header and the onboarding chrome.
 * A native <select> on purpose: seven languages is past what a button row can
 * carry, and the native control is keyboard/screen-reader accessible for free.
 */
export default function LanguagePicker({ className = '' }) {
  const { lang, setLang } = useLang()

  return (
    <select
      className={`lang-picker ${className}`.trim()}
      value={lang}
      onChange={(e) => setLang(e.target.value)}
      aria-label="Language"
    >
      {LANGUAGES.map((l) => (
        <option key={l.code} value={l.code}>
          {l.flag} {l.label}
        </option>
      ))}
    </select>
  )
}
